export const CHAT_LISTENER_EVENTS = {
  UPDATE_CONVERSATION: 'ConversationUpdated',
  NEW_MESSAGE: 'NewMessage',
  UPDATE_MESSAGE: 'MessageUpdated'
};
export const MESSAGES_DEFAULT_LIMIT = 30;
export const CONVERSATIONS_DEFAULT_LIMIT = 30;

export const CHAT_MAXIMUM_ATTACHMENTS_SIZE = 5;
export const CHAT_MAXIMUM_ATTACHMENTS_PER_MESSAGE = 10;
export const CHAT_MAX_CHARACTERS_LIMIT = 1000;
